import call from "@/conn-global/api";

export default {
  getDataDashboard: async ({ commit }) => {
    await call
      .get("/v1/dashboard/get_dashboard", true)
      .then((res) => {
        if (res != undefined) {
          // console.log(res.data.data);
          commit("addDataDashboard", res.data.data.customer_global);
          commit("setListSnapTransaksi", res.data.data.list_snap_transaksi);
          commit("setJumlahMesin", res.data.data.list_snap_transaksi);
        }
      })
      .catch((err) => {
        // localStorage.removeItem("token");
        console.log(err);
      });
  },

  getCustomerByID: async ({ commit }) => {
    // console.log("getCustomerByID action called");
    let response = await call
      .get("/v1/dashboard/get_user_epayment_by_id_customer_global", true)
      .then((res) => {
        if (res != undefined) {
          commit("userEpayByID", res.data.data);
          return res.data;
        }
      })
      .catch((err) => {
        if (err) {
          localStorage.removeItem("token");
        }
      });
    return response;
  },
};
